import React, { useEffect, useState } from 'react'
import { companionsApi, CompanionItem, Paginated } from '../../../shared/api/companions'
import { Link } from 'react-router-dom'

const CompanionsPage: React.FC = () => {
  const [data, setData] = useState<Paginated<CompanionItem> | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let mounted = true
    companionsApi
      .list(1, 20)
      .then((res) => { if (mounted) { setData(res); setError(null) } })
      .catch((e) => setError(e?.message || '加载失败'))
      .finally(() => setLoading(false))
    return () => { mounted = false }
  }, [])

  if (loading) return <div className="p-4">加载中...</div>
  if (error) return <div className="p-4 text-red-600">{error}</div>
  if (!data || data.items.length === 0) return <div className="p-4">暂无陪跑员</div>

  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-4">陪跑员列表</h1>
      <ul className="space-y-3">
        {data.items.map((r) => (
          <li key={r.id} className="p-3 border rounded">
            <Link to={`/runner/${r.id}`} className="font-medium text-orange-600">{r.name}</Link>
            <div className="text-sm text-gray-500">{r.city || '未知'} · 评分 {r.rating ?? 0}（{r.review_count ?? 0}）</div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default CompanionsPage

